import axios from 'axios'
import { getToken, getSessionToken } from './helper'
import { removeLocalStorage, removeSessionStorage } from './localStorage'

const service = axios.create({})

service.interceptors.request.use(
  (config) => {
    if (!config.data) {
      config.headers['Content-Type'] = ''
    }
    config.headers['GS-Enphase-Auth'] = getSessionToken() || getToken()
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)
service.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      removeLocalStorage('auth')
      removeSessionStorage('auth')
      removeLocalStorage('session_id')
      window.location = '/'
    }
    return Promise.reject(error.response)
  },
)

export default service
